module.exports = __webpack_public_path__ + "static/media/Rectangle 9 (4).6646321d.png";